import { IPhoneInputProps } from "interfaces";
import { useEffect, useState } from "react";

const PhoneInput = ({ onChange, value, label, placeholder, disable, error, parentClassName, autoFocus }: IPhoneInputProps) => {
  const [inputValue, setInputValue] = useState(value ? value : '');

  useEffect(() => {
    if (onChange)
      onChange(inputValue);
  }, [inputValue]);

  useEffect(() => {
    if (value) setInputValue(value);
  }, []);

  useEffect(() => {
    if (inputValue !== value && value) setInputValue(value.replaceAll("_", "").replaceAll(" ", ""));
  }, [value])

  function onChangeHandler(e: any) {
    let value = e.target.value
    if (!value.startsWith("0") && !(value.length < 1)) {
      value = "0" + value
    }
    const formattedPhoneNumber = formatPhoneNumber(value).trim();
    setInputValue(formattedPhoneNumber);
  }

  function formatPhoneNumber(input:any) {
    if (!input) return input;
    const numberInput = input.replace(/[^\d]/g, "");

    return `${numberInput.slice(0, 4)} ${numberInput.slice(4, 7)} ${numberInput.slice(7, 11)}`;
  }

  const inputKeyDown = (e:any ) => {
    if (e.code === "Backspace" || e.code === "Delete") {
      setInputValue(inputValue.replaceAll(" ", ""))
    }
  }

  return (
    <div className={parentClassName}>
      {label && <label className={`pl-text-[14px] pl-font-normal pl-text-gray-800 dark:pl-text-z-secondary-50 pl-mb-1 ${disable && 'pl-text-gray-300 pl-opacity-50'}`}>{label}</label>}
      <div className="pl-z-0 pl-group pl-relative pl-flex pl-items-center">
        <input
          dir="ltr"
          placeholder={placeholder}
          autoFocus={autoFocus}
          onKeyDown={inputKeyDown}
          onChange={onChangeHandler}
          value={inputValue}
          disabled={disable}
          className={`pl-outline-none pl-rounded-[10px] pl-transition-all pl-flex pl-items-center pl-text-[14px] pl-text-left pl-bg-secondary-200 dark:pl-bg-dark-1 pl-h-full pl-w-full pl-p-4 pl-border-[1.5px] pl-border-solid pl-border-transparent placeholder:dark:pl-text-secondary placeholder:pl-text-left ${error && "pl-border-red-500"}`}
        />
        
        <input type="password" className={"pl-hidden"} />
      </div>
      {error && <div className="pl-text-[14px] pl-mt-2 pl-text-red-500">{error}</div>}
    </div>
  )
}

export default PhoneInput;